import styled, { css } from 'styled-components/macro';

type EyeToggleIconProps = {
  crossed: boolean;
};

const Strike = styled.path<{ $crossed: boolean }>`
  ${({ theme, $crossed }) => css`
    stroke: currentColor;
    stroke-width: 1.5;
    stroke-linecap: round;
    stroke-dasharray: 13;
    stroke-dashoffset: ${$crossed ? 0 : 13};
    transition: stroke-dashoffset ${theme.tokens.animation.duration.base}
      ${theme.tokens.animation.easing.standard};
  `}
`;

export const EyeToggleIcon = ({ crossed }: EyeToggleIconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.23636 8.00008C5.23636 6.49823 6.50301 5.33341 7.99898 5.33341C9.49495 5.33341 10.7616 6.49823 10.7616 8.00008C10.7616 9.50194 9.49495 10.6667 7.99898 10.6667C6.50301 10.6667 5.23636 9.50194 5.23636 8.00008ZM7.99898 6.66675C7.17982 6.66675 6.56969 7.2928 6.56969 8.00008C6.56969 8.70736 7.17982 9.33341 7.99898 9.33341C8.81814 9.33341 9.42826 8.70737 9.42826 8.00008C9.42826 7.2928 8.81814 6.66675 7.99898 6.66675Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.699466 7.79162C1.68245 4.80524 4.59193 2.66675 7.99937 2.66675C11.4068 2.66675 14.3163 4.80527 15.2993 7.79167L15.3679 8.00011L15.2993 8.20854C14.3163 11.1949 11.4068 13.3334 7.99939 13.3334C4.59193 13.3334 1.68243 11.1949 0.699464 8.20849L0.630859 8.00006L0.699466 7.79162ZM2.03905 8.00006C2.90183 10.3164 5.23254 12.0001 7.99939 12.0001C10.7662 12.0001 13.0969 10.3164 13.9597 8.0001C13.0969 5.68376 10.7662 4.00008 7.99937 4.00008C5.23254 4.00008 2.90184 5.68373 2.03905 8.00006Z"
      fill="currentColor"
    />
    <Strike $crossed={crossed} d="M3.5 3.5L12.5 12.5" />
  </svg>
);
